export default __webpack_public_path__ + "static/media/Dragon Scale Mantle of the Living Legend.d45520cb.jpg";